import React from "react";
import authUtil from "utils/auth";
import queryStringifierUtil from "utils/query-stringifier";
import alertUtil from "utils/alert";
function Callback({ location, history }) {
  const { access_token } = queryStringifierUtil.parse(location.hash);
  const redirectTo = "/dashboard";

  try {
    authUtil.setToken(access_token);
  } catch (error) {
    alertUtil.unexpectedError(error);
  } finally {
    history.push(redirectTo);
  }
  return <p className="is-size-6 loading-text">Redirect...</p>;
}

export default Callback;



// WEBPACK FOOTER //
// ./src/pages/LoginCallback/index.js